import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconUser = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-user" data-icon="icon-user" aria-hidden="true" {...props} ref={ref}><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>);
});

IconUser.displayName = 'IconUser';
